import { AcceptInviteFnReq, AcceptInviteFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class AcceptInviteInteractor {
  private readonly acceptInviteFn = httpsCallable<AcceptInviteFnReq, AcceptInviteFnRes>(
    this.functions,
    'acceptInvite',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(): Promise<void> {
    await this.acceptInviteFn();
  }
}
